export class GetYepdeskEventAction{
    static readonly type = '[GET YEPDESK EVENTS] fetchYepdeskEvents';
    }